import { motion } from "framer-motion";
import { LogoMark } from "./Logo";

const EASE = [0.22, 1, 0.36, 1];
const reveal = {
  initial: { opacity: 0.001, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
};

const PRINCIPLES = [
  { n: "I", t: "Mineral Swirl", d: "Blends of multiple mineral pigments are folded into the wet composite by hand in a single, unrepeatable gesture. The swirl is never drawn — it is allowed to happen, the way sediment settles or a shell coils around its own growth." },
  { n: "II", t: "Stone Density", d: "A dense, cold body of mineral powders and stone aggregates. Each object carries real weight in the hand, cures slowly through time, and wherever possible, is finished with a natural cork base to protect delicate surfaces while retaining the raw, porous edge of unrefined rock." },
  { n: "III", t: "Singularity", d: "Because the process unfolds in a single fluid gesture, no two pieces ever share the same pattern. Each object is individually numbered — a quiet fossil of the moment it was cast." },
  { n: "IV", t: "Creation & Time", d: "Each piece is individual, hand-cast, and meticulously cured in our atelier. Estimated creation time is typically 7–14 business days, depending on current commission volumes and the natural setting cycles of our mineral compounds. Quality and distinction remain our sole priorities." },
];

export const Philosophy = () => (
  <section id="philosophy" className="relative py-20 md:py-32 px-5 md:px-14 bg-slate overflow-hidden" data-testid="philosophy-section">
    <div className="grain" />
    <div className="relative max-w-3xl mx-auto text-center">
      <motion.div {...reveal} transition={{ duration: 1.2, ease: EASE }} className="flex flex-col items-center">
        <LogoMark className="w-10 h-10 text-sand mb-8" />
        <p className="label mb-6">II — Philosophy</p>
        <h2 className="font-serif text-bone font-light text-4xl md:text-6xl leading-[1.05]">
          Translating universal proportion<br /><em>into permanent, mineral form.</em>
        </h2>
      </motion.div>
      <div className="mt-14 md:mt-20 space-y-12 md:space-y-16">
        {PRINCIPLES.map((p, i) => (
          <motion.div key={p.n} {...reveal} transition={{ duration: 1.2, delay: i * 0.08, ease: EASE }} data-testid={`principle-${i}`}>
            <span className="font-serif italic text-sand text-lg">{p.n}</span>
            <h3 className="font-serif text-bone text-2xl md:text-3xl font-light mt-2 mb-4">{p.t}</h3>
            <p className="body max-w-xl mx-auto">{p.d}</p>
            {i < PRINCIPLES.length - 1 && <span className="block w-px h-12 bg-bone/15 mx-auto mt-12 md:mt-16" />}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);